import { Filter, NumberInput, SearchInput, usePermissions } from "react-admin";
import React, { useCallback } from "react";

import CompanyTypeEntryInput from "../component/input/CompanyTypeEntryInput";
import ProductionChainInput from "./inputs/ProductionChainInput";
import ResearchAreaInput from "./inputs/ResearchAreaInput";
import { StateInput } from "ra-friendsofbabba";
import useView from "./useView";

const Filters = (props) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions(["admin", "reader"]);
  const isView = useView();
  const handleFilter = useCallback(
    (s) =>
      [
        "admissible",
        "not_admissible",
        "to_be_checked",
        "integrations_requested",
        "integrations_received",
      ].indexOf(s.code) !== -1,
    []
  );
  return (
    <Filter {...props}>
      <SearchInput source="q" alwaysOn />
      {isView && (
        <StateInput
          fullWidth
          style={{ minWidth: 200 }}
          emptyText="ra.action.all"
          source="admissibility_status"
          filter={handleFilter}
        />
      )}
      {!isView && <StateInput source="state" alwaysOn />}
      {(isAdmin || isView) && (
        <NumberInput source="from_progressive_number" fullWidth />
      )}
      {(isAdmin || isView) && (
        <NumberInput source="to_progressive_number" fullWidth />
      )}
      {(isAdmin || isView) && (
        <CompanyTypeEntryInput
          fullWidth
          source="company_type_entry_id"
          alwaysOn={isView}
        />
      )}
      {(isAdmin || isView) && (
        <ResearchAreaInput
          label="ADR - L1"
          level={1}
          source="research_area_id_root"
          emptyText="ra.action.all"
        />
      )}
      {(isAdmin || isView) && (
        <ResearchAreaInput
          label="ADR - L2"
          level={2}
          emptyText="ra.action.all"
          source="research_area_id"
          dependency="research_area_id_root"
        />
      )}
      {(isAdmin || isView) && (
        <ProductionChainInput
          style={{ minWidth: 300 }}
          source="production_chain_id"
          emptyText="ra.action.all"
        />
      )}
    </Filter>
  );
};
export default Filters;
